module.exports = __webpack_public_path__ + "static/media/logo3.c047f6ec.png";